


























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































declare const google: any;
declare const $: any;
import Vue from 'vue';
import VueTagsInput from '@johmun/vue-tags-input';
import axios from 'axios';
import moment from 'moment';
import {
    AppConstants,
    emailRegex,
    summernoteToolbar,
    EmailTemplateTag,
} from '@/app.constants';
import * as Ladda from 'ladda';
import { Utils } from '@/Utils';
import { store } from '@/store';
import {
    fetchRegionalCampaigns,
    fetchAdminCampaigns,
    setHasAdminCampaigns,
    getAllSignUps,
    setAdminCampaigns,
} from '@/actions';
import unionBy from 'lodash.unionby';
import Titlebar from './components/TitleBar.vue';
import {
    EmployerInfo,
    Campaign,
    Role,
    Region,
    SalesforceEmployerLocation,
    JoinSurveyQuestionType,
    Languages,
    User,
} from '@/types';
import { AgGridVue } from '@ag-grid-community/vue';
import {
    ColDef,
    GridOptions,
    AllModules,
    QuerySelector,
} from '@ag-grid-enterprise/all-modules';
const signupTextHtml = require('../../assets/html/signup_text_en.html');
const emailTemplate = require('../../assets/html/emailTemplate.html');

type Tags = {
    text: string;
    tiClasses?: string[];
};

interface AddCampaignForm {
    path: string; // key
    allowOther: boolean;
    allowOtherJobTitle: boolean;
    title: string;
    localNumber: string;
    description?: string;
    employerNames?: EmployerInfo[];
    departments?: string[];
    jobTitles?: string[];
    replyEmail?: string;
    region: string;
    status: string;
    adminTags?: Tags[];
    admin?: string;
    campaignAdmins?: string[];
    header?: string;
    emailTemplate?: string;
    submissionTemplate?: string;
    uiTags?: Tags[];
    tags?: string | string[];
    enabledDemographicFields?: string[];
    requiredFields?: string[];
    joinSurveyResponsesOne?: string[];
    joinSurveyResponsesOneTags?: Tags[];
    joinSurveyResponsesTwo?: string[];
    joinSurveyResponsesTwoTags?: Tags[];
    joinSurveyResponsesThree?: string[];
    joinSurveyResponsesThreeTags?: Tags[];
    joinSurveyResponsesFour?: string[];
    joinSurveyResponsesFourTags?: Tags[];
    sms_message: string;
    enable_sms: boolean;
    referrer: boolean;
    starLabel: string;
    joinSurveyHeaderOne: string;
    joinSurveyHeaderTwo: string;
    joinSurveyHeaderThree: string;
    joinSurveyHeaderFour: string;
    joinSurveyQuestionOneType: string;
    joinSurveyQuestionTwoType: string;
    joinSurveyQuestionThreeType: string;
    joinSurveyQuestionFourType: string;
    disabled: boolean;
    unitSize: number;
    enableDigitalCards: boolean;
    salesforceEnabled: boolean;
    defaultLanguage: string;
}

interface EditCampaignForm extends AddCampaignForm {
    id?: number | null;
    isEditable?: boolean;
}

interface WebLink extends AddCampaignForm {
    id: number;
    data: {
        employers?: EmployerInfo[];
        departments: string[];
        jobTitles?: string[];
        replyEmail: string;
        allowOther: boolean;
        allowOtherJobTitle: boolean;
        salesforceEmployerLocations: SalesforceEmployerLocation[];
    };
    readWrite?: boolean;
    adminCount?: number;
}

interface FilterOpts {
    regions: String[];
}

interface Filters {
    regions: String[];
    campaign: string;
    noAdmins: boolean;
}

interface BulkCampaign {
    id: number;
    title: string;
    path: string;
    region: string;
    status: string;
}

interface BulkReassignOp {
    allUsers: User[];
    allCampaigns: BulkCampaign[];
    selectedUser: User | null;
    userCampaigns: BulkCampaign[];
    selectedCampaignIds: number[];
    newManagerEmail: string;
    loading: boolean;
    error: string;
    selectAll: boolean;
}

interface Data {
    userRegions: string[];
    gridOptions: GridOptions;
    bulkOp: BulkReassignOp;
    columnDefs: ColDef[];
    rowData: WebLink[];
    columnTypes: {
        [key: string]: ColDef;
    };
    form: EditCampaignForm;
    employerBox: any;
    selectedCampaigns: WebLink[];
    filterOpts: FilterOpts;
    filters: Filters;
    emailTagValidation: {
        classes: string;
        rule: RegExp | Function;
        disableAdd?: boolean;
    }[];
    campaignUsers: string[];
    modules: typeof AllModules;
    regions: Region[];
    loading: {
        signupsExport: boolean;
        cardsExport: boolean;
    };
    popoverMsg: string;

    surveyQuestionTypes: string[];
}

export default Vue.extend({
    name: 'campaigns',

    data(): Data {
        return {
            gridOptions: {
                getRowNodeId: d => {
                    return d.id;
                },
            },
            userRegions:
                (store.token &&
                    store.token.regions.sort((a, b) => (a > b ? 1 : -1))) ||
                [],
            columnDefs: null,
            rowData: null,
            columnTypes: null,
            form: {
                path: '',
                title: '',
                localNumber: '',
                description: '',
                allowOther: true,
                employerNames: [
                    {
                        name: '',
                        location: {},
                    },
                ],
                departments: [''],
                jobTitles: [''],
                replyEmail: '',
                region: '',
                adminTags: [],
                header: '',
                status: '',
                enabledDemographicFields: ['Email'],
                requiredFields: ['Email'],
                joinSurveyResponsesOneTags: [],
                joinSurveyResponsesTwoTags: [],
                joinSurveyResponsesThreeTags: [],
                joinSurveyResponsesFourTags: [],
                enable_sms: false,
                sms_message: '',
                tags: [],
                referrer: true,
                starLabel: '',
                joinSurveyHeaderOne: '',
                joinSurveyHeaderTwo: '',
                joinSurveyHeaderThree: '',
                joinSurveyHeaderFour: '',
                joinSurveyQuestionOneType:
                    JoinSurveyQuestionType[JoinSurveyQuestionType.MultiChoice],
                joinSurveyQuestionTwoType:
                    JoinSurveyQuestionType[JoinSurveyQuestionType.MultiChoice],
                joinSurveyQuestionThreeType:
                    JoinSurveyQuestionType[JoinSurveyQuestionType.MultiChoice],
                joinSurveyQuestionFourType:
                    JoinSurveyQuestionType[JoinSurveyQuestionType.MultiChoice],
                disabled: false,
                allowOtherJobTitle: false,
                unitSize: 0,
                enableDigitalCards: true,
                salesforceEnabled: false,
                defaultLanguage: 'en',
            },
            employerBox: null,
            selectedCampaigns: [],
            filterOpts: {
                regions: [],
            },
            filters: {
                regions: [],
                campaign: '',
                noAdmins: false,
            },
            emailTagValidation: [
                {
                    classes: 'invalid',
                    rule: emailRegex,
                    // disableAdd: true
                },
            ],
            campaignUsers: [],
            modules: AllModules,
            regions: Object.keys(Region).map(key => Region[key]),
            loading: {
                signupsExport: false,
                cardsExport: false,
            },
            popoverMsg: '',
            surveyQuestionTypes: Object.keys(
                JoinSurveyQuestionType
            ).filter(key => isNaN(Number(key))),
            bulkOp: {
                allUsers: [],
                allCampaigns: [],
                selectedUser: null,
                userCampaigns: [],
                selectedCampaignIds: [],
                newManagerEmail: '',
                loading: false,
                error: '',
                selectAll: false,
            },
        };
    },
    props: {
        campaignPath: {
            type: String,
            required: false,
        },
    },
    methods: {
        log: console.log,
        getPropertyToken: async function() {
            await axios
                .get(
                    `${process.env.VUE_APP_API_URI}/api/admin/get-member-properties`
                )
                .then(res => {
                    this.popoverMsg = `These are eligible tokens to be included in your message:\n${res.data}`;
                });
        },
        enableSMS: function(event) {
            if (!this.form.sms_message || this.form.sms_message === '') {
                this.form.sms_message =
                    'Thank you for your confirmation with the UFCW at https://yes.ufcw.org/' +
                    this.form.path;
            }
        },
        logout: function(event) {
            localStorage.removeItem(AppConstants.LocalStorageKeys.jwt);
            window.location.reload();
        },
        onRowDataChanged() {
            Vue.nextTick(() => {
                (this.gridOptions as GridOptions).api.sizeColumnsToFit();
            });
        },
        resetForm() {
            this.form = {
                path: '',
                title: '',
                tags: '',
                localNumber: '',
                description: '',
                allowOther: true,
                employerNames: [
                    {
                        name: '',
                        location: {},
                    },
                ],
                departments: [''],
                jobTitles: [''],
                replyEmail: '',
                region: '',
                status: '',
                enabledDemographicFields: ['Email'],
                requiredFields: ['Email'],
                joinSurveyResponsesOne: [],
                joinSurveyResponsesTwo: [],
                joinSurveyResponsesThree: [],
                joinSurveyResponsesFour: [],
                sms_message: '',
                enable_sms: false,
                referrer: true,
                starLabel: '',
                joinSurveyHeaderOne: '',
                joinSurveyHeaderTwo: '',
                joinSurveyHeaderThree: '',
                joinSurveyHeaderFour: '',
                joinSurveyQuestionOneType:
                    JoinSurveyQuestionType[JoinSurveyQuestionType.MultiChoice],
                joinSurveyQuestionTwoType:
                    JoinSurveyQuestionType[JoinSurveyQuestionType.MultiChoice],
                joinSurveyQuestionThreeType:
                    JoinSurveyQuestionType[JoinSurveyQuestionType.MultiChoice],
                joinSurveyQuestionFourType:
                    JoinSurveyQuestionType[JoinSurveyQuestionType.MultiChoice],
                disabled: false,
                unitSize: 0,
                enableDigitalCards: true,
                salesforceEnabled: false,
                defaultLanguage: 'en',
            } as AddCampaignForm;
        },
        resetGridState() {
            localStorage.removeItem('ufcw-authcards-grid-state');
            this.gridOptions.columnApi.resetColumnState();
            this.gridOptions.columnApi.resetColumnGroupState();
            this.gridOptions.api.setSortModel([
                { colId: 'dateCreated', sort: 'desc' },
            ]);
            this.gridOptions.api.setFilterModel(null);
            this.filters.noAdmins = false;
        },
        loadGridState() {
            let gridState = localStorage.getItem(
                'ufcw-authcards-grid-state-campaigns'
            );
            if (gridState != null) {
                let gridStateObj = JSON.parse(gridState) as any;
                this.gridOptions.columnApi.setColumnState(
                    gridStateObj.colState
                );
                this.gridOptions.columnApi.setColumnGroupState(
                    gridStateObj.groupState
                );
                this.gridOptions.api.setSortModel(gridStateObj.sortState);
                this.gridOptions.api.setFilterModel(gridStateObj.filterState);
            }
        },
        onStateChanged(e) {
            const gridState = {
                colState: this.gridOptions.columnApi.getColumnState(),
                groupState: this.gridOptions.columnApi.getColumnGroupState(),
                sortState: this.gridOptions.api.getSortModel(),
                filterState: this.gridOptions.api.getFilterModel(),
            };
            localStorage.setItem(
                'ufcw-authcards-grid-state-campaigns',
                JSON.stringify(gridState)
            );
        },
        setupAutocomplete: function() {
            let employerInput;
            employerInput = document.querySelectorAll(
                '.employerAutocomplete'
            ) as NodeListOf<HTMLInputElement>;
            const employerInputs: HTMLInputElement[] = [...employerInput];

            employerInputs.forEach((input, i) => {
                let employerBox;

                employerBox = this.form.employerNames[
                    i
                ].gPlaces = new google.maps.places.Autocomplete(input, {
                    componentRestrictions: { country: ['us', 'ca'] },
                });

                employerBox.addListener('place_changed', () => {
                    this.form.employerNames[i].name = Utils.formatEmployerName(
                        employerBox.getPlace()
                    );
                    this.form.employerNames[
                        i
                    ].location = employerBox.getPlace();
                });
            });
        },
        initPopovers() {
            $('[data-toggle="popover"]').popover();
        },
        addCreateEmployer() {
            this.form.employerNames.push({
                name: '',
                location: {},
            });
            Vue.nextTick(() => {
                this.setupAutocomplete();
                this.initPopovers();
            });
        },
        employerInputChange(event, i: number) {
            if (!event.target.value) {
                Vue.set(this.form.employerNames[i], 'location', {});
            }
        },
        deleteEmployer(i, form) {
            const targetForm = form || this.form;
            targetForm.employerNames.splice(i, 1);
        },
        removeInvalid() {
            document.querySelector('#region').classList.remove('text-danger');
            document.querySelector('#region-label').classList.add('hidden');
        },
        isRegionValid() {
            if (this.form.region == '') {
                document.querySelector('#region').classList.add('text-danger');
                document
                    .querySelector('#region-label')
                    .classList.remove('hidden');
                return false;
            } else {
                return true;
            }
        },
        handleCampaignSubmit() {
            if (this.form.id) {
                this.editCampaign();
            } else {
                this.addCampaign();
            }
        },
        openAddModal() {
            this.$modal.show('campaign-modal');
        },
        addCampaign() {
            this.$validator.validateAll().then(result => {
                if (this.form.region == '') this.isRegionValid();
                if (result) {
                    const ladda = Ladda.create(
                        document.querySelector('.add-btn') as HTMLButtonElement
                    );

                    ladda.start();
                    let form: AddCampaignForm = { ...this.form };

                    form.path = encodeURIComponent(form.path);

                    form.campaignAdmins =
                        form.adminTags &&
                        form.adminTags.map(admin => {
                            return (admin as any).text;
                        });

                    form.tags =
                        form.uiTags &&
                        form.uiTags.map(x => {
                            return (x as any).text;
                        });

                    form.joinSurveyResponsesOne =
                        form.joinSurveyResponsesOneTags &&
                        form.joinSurveyResponsesOneTags.map(x => {
                            return (x as any).text;
                        });

                    form.joinSurveyResponsesTwo =
                        form.joinSurveyResponsesTwoTags &&
                        form.joinSurveyResponsesTwoTags.map(x => {
                            return (x as any).text;
                        });

                    form.joinSurveyResponsesThree =
                        form.joinSurveyResponsesThreeTags &&
                        form.joinSurveyResponsesThreeTags.map(x => {
                            return (x as any).text;
                        });

                    form.joinSurveyResponsesFour =
                        form.joinSurveyResponsesFourTags &&
                        form.joinSurveyResponsesFourTags.map(x => {
                            return (x as any).text;
                        });

                    const hasInvalidEmail =
                        form.campaignAdmins &&
                        form.campaignAdmins.some(email => {
                            return !emailRegex.test(email);
                        });

                    if (hasInvalidEmail) {
                        Utils.toastError(
                            'Invalid email entered for campaign admin'
                        );
                        ladda.stop();
                        return;
                    }

                    form.employerNames.forEach((emp, i) => {
                        if (emp.name) {
                            delete emp.gPlaces;
                        } else {
                            form.employerNames.splice(i, 1);
                        }
                    });

                    form.departments = form.departments.filter(Boolean).sort();

                    form.jobTitles = form.jobTitles.filter(Boolean).sort();

                    if (!form.header) {
                        form.header = signupTextHtml;
                    }
                    axios
                        .post<WebLink>(
                            `${process.env.VUE_APP_API_URI}/api/admin/weblinks/addcampaign`,
                            form
                        )
                        .then(val => {
                            ladda.stop();
                            if (val.status === 200 && val.data) {
                                const newCampaign = {
                                    ...val.data,
                                    readWrite: true,
                                };
                                this.rowData.push(newCampaign);
                                this.$modal.hide('campaign-modal');
                            }
                        })
                        .catch(err => {
                            let errorMessage = '';
                            if (err.response && err.response.status === 400) {
                                errorMessage =
                                    'Sorry, this link is unavailable';
                            } else {
                                errorMessage =
                                    'Oops, an error occurred. Please try again later.';
                            }
                            Utils.toastError(errorMessage);
                            ladda.stop();
                        });
                }
            });
        },
        editCampaign() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    const ladda = Ladda.create(
                        document.querySelector('.add-btn') as HTMLButtonElement
                    );
                    ladda.start();
                    const form: EditCampaignForm = { ...this.form };
                    const employerLocation =
                        this.employerBox && this.employerBox.getPlace();

                    form.path = form.path;

                    form.campaignAdmins =
                        form.adminTags &&
                        form.adminTags.map(admin => {
                            return (admin as any).text;
                        });

                    form.tags =
                        form.uiTags &&
                        form.uiTags.map(x => {
                            return (x as any).text;
                        });
                    form.joinSurveyResponsesOne =
                        form.joinSurveyResponsesOneTags &&
                        form.joinSurveyResponsesOneTags.map(x => {
                            return (x as any).text;
                        });

                    form.joinSurveyResponsesTwo =
                        form.joinSurveyResponsesTwoTags &&
                        form.joinSurveyResponsesTwoTags.map(x => {
                            return (x as any).text;
                        });

                    form.joinSurveyResponsesThree =
                        form.joinSurveyResponsesThreeTags &&
                        form.joinSurveyResponsesThreeTags.map(x => {
                            return (x as any).text;
                        });

                    form.joinSurveyResponsesFour =
                        form.joinSurveyResponsesFourTags &&
                        form.joinSurveyResponsesFourTags.map(x => {
                            return (x as any).text;
                        });

                    const hasInvalidEmail =
                        form.campaignAdmins &&
                        form.campaignAdmins.some(email => {
                            return !emailRegex.test(email);
                        });

                    if (hasInvalidEmail) {
                        Utils.toastError(
                            'Invalid email entered for campaign admin'
                        );
                        ladda.stop();
                        return;
                    }

                    if (form.employerNames) {
                        form.employerNames.forEach((emp, i) => {
                            if (emp.name) {
                                delete emp.gPlaces;
                            } else {
                                form.employerNames.splice(i, 1);
                            }
                        });
                    }

                    form.departments = form.departments.filter(Boolean).sort();

                    form.jobTitles = form.jobTitles.filter(Boolean).sort();

                    if (!form.header) {
                        form.header = signupTextHtml;
                    }

                    axios
                        .post<WebLink>(
                            `${process.env.VUE_APP_API_URI}/api/admin/weblinks/editcampaign`,
                            form
                        )
                        .then(val => {
                            ladda.stop();
                            if (val.status === 200 && val.data) {
                                let row = this.gridOptions.api.getRowNode(
                                    val.data.id.toString()
                                );
                                const newCampaign = {
                                    ...val.data,
                                    readWrite: form.isEditable,
                                };
                                row.setData(newCampaign);
                                // this.gridOptions.api.refreshCells();
                                this.$modal.hide('campaign-modal');
                            }
                        })
                        .catch(err => {
                            let errorMessage = '';
                            if (err.response && err.response.status === 400) {
                                errorMessage =
                                    'Sorry, this link is unavailable';
                            } else if (err.response.status === 403) {
                                errorMessage =
                                    "You don't have permission to update this campaign";
                            } else {
                                errorMessage =
                                    'Oops, an error occurred. Please try again later.';
                            }
                            Utils.toastError(errorMessage);
                        });
                }
            });
        },
        openEditModal() {
            this.getSelectedRows();

            if (this.selectedCampaigns.length > 1) {
                Utils.toastError('Only one campaign can be edited at a time');
                return;
            } else if (this.selectedCampaigns.length < 1) {
                Utils.toastError('Please select a campaign to edit');
                return;
            }

            this.populateEditModal();
        },
        onRowDoubleClick({ data }) {
            this.populateEditModal(data);
        },
        openDeleteModal() {
            // $('#delete-campaigns-modal').modal('show');
            this.$modal.show('delete-modal');
            this.getSelectedRows();
        },
        closeDeleteModal() {
            // $('#delete-campaigns-modal').modal('hide');
            this.$modal.hide('delete-modal');
        },
        exportData() {
            const selectedRows = this.gridOptions.api.getSelectedRows();
            const selectedIds = selectedRows.map(row => row.id);
            this.selectedCampaigns = selectedRows;
            const sortModel = this.gridOptions.api.getSortModel();
            const filterModel = this.gridOptions.api.getFilterModel();

            axios
                .post<string>(
                    `${process.env.VUE_APP_API_URI}/api/admin/campaigns/export`,
                    {
                        startRow: 0,
                        endRow: 0,
                        sortModel,
                        filterModel,
                        employerName: this['filters']['employer'],
                        campaign: this['filters']['campaign'],
                        regions: this['filters']['regions'],
                        ids: selectedIds,
                    }
                )
                .then(val => {
                    // the "\ufeff" below is a hack that makes it work with unicode
                    // See https://stackoverflow.com/questions/17879198/adding-utf-8-bom-to-string-blob for more info
                    const blob = new Blob(['\ufeff', val.data], {
                        type: 'application/csv',
                    });
                    const blobUrl = URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.setAttribute('href', blobUrl);

                    link.setAttribute('download', 'Campaigns.csv');
                    link.innerHTML = 'Click Here to download';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                })
                .catch(err => {
                    let errorMessage = '';
                    if (
                        err.response &&
                        err.response.status ===
                            AppConstants.HttpStatusCode.Unauthorized
                    ) {
                        errorMessage =
                            'Unauthorized: please log out and back in';
                    } else {
                        errorMessage =
                            "Couldn't retrieve the data. Please try again later";
                    }
                    Utils.toastError(errorMessage);
                });
        },
        populateEditModal(campaign?: Campaign) {
            let camp = campaign || (this.selectedCampaigns[0] as WebLink);
            this.campaignUsers = [];

            axios
                .get(
                    `${process.env.VUE_APP_API_URI}/api/admin/weblinks/${camp.id}`
                )
                .then(res => {
                    let camp = res.data as WebLink;
                    axios
                        .get(
                            `${process.env.VUE_APP_API_URI}/api/admin/weblinks/admins/${camp.id}`
                        )
                        .then(res => {
                            const adminTags = res.data.map(admin => {
                                return {
                                    text: admin,
                                    tiClasses: ['ti-valid'],
                                };
                            });
                            const tags = !Array.isArray(camp.tags)
                                ? camp.tags?.split(',').map(x => {
                                      return { text: x };
                                  })
                                : [];

                            const joinSurveyResponsesOneTags =
                                camp.joinSurveyResponsesOne?.map(x => {
                                    return { text: x };
                                }) || [];

                            const joinSurveyResponsesTwoTags =
                                camp.joinSurveyResponsesTwo?.map(x => {
                                    return { text: x };
                                }) || [];

                            const joinSurveyResponsesThreeTags =
                                camp.joinSurveyResponsesThree?.map(x => {
                                    return { text: x };
                                }) || [];

                            const joinSurveyResponsesFourTags =
                                camp.joinSurveyResponsesFour?.map(x => {
                                    return { text: x };
                                }) || [];

                            this.form = {
                                id: camp.id,
                                allowOther: camp.data.allowOther,
                                path: camp.path,
                                title: camp.title,
                                localNumber: camp.localNumber,
                                status: camp.status || 'active',
                                description: camp.description,
                                employerNames: camp.data.employers,
                                adminTags: adminTags,
                                replyEmail: camp.data.replyEmail,
                                region: camp.region,
                                referrer: camp.referrer,
                                starLabel: camp.starLabel || '',
                                enabledDemographicFields:
                                    camp.enabledDemographicFields || [],
                                requiredFields: camp.requiredFields,
                                joinSurveyResponsesOneTags: joinSurveyResponsesOneTags,
                                joinSurveyResponsesTwoTags: joinSurveyResponsesTwoTags,
                                joinSurveyResponsesThreeTags: joinSurveyResponsesThreeTags,
                                joinSurveyResponsesFourTags: joinSurveyResponsesFourTags,
                                joinSurveyHeaderOne: camp.joinSurveyHeaderOne,
                                joinSurveyHeaderTwo: camp.joinSurveyHeaderTwo,
                                joinSurveyHeaderThree:
                                    camp.joinSurveyHeaderThree,
                                joinSurveyHeaderFour: camp.joinSurveyHeaderFour,
                                sms_message: camp.sms_message,
                                enable_sms: camp.enable_sms,
                                header: camp.header || signupTextHtml,
                                submissionTemplate:
                                    camp.submissionTemplate || '',
                                emailTemplate:
                                    camp.emailTemplate || emailTemplate,
                                isEditable: camp.readWrite || false,
                                uiTags: tags,
                                departments:
                                    (camp.data.departments &&
                                        camp.data.departments.sort()) ||
                                    [],
                                jobTitles:
                                    (camp.data.jobTitles &&
                                        camp.data.jobTitles.sort()) ||
                                    [],
                                joinSurveyQuestionOneType:
                                    camp.joinSurveyQuestionOneType,
                                joinSurveyQuestionTwoType:
                                    camp.joinSurveyQuestionTwoType,
                                joinSurveyQuestionThreeType:
                                    camp.joinSurveyQuestionThreeType,
                                joinSurveyQuestionFourType:
                                    camp.joinSurveyQuestionFourType,
                                disabled: camp.disabled,
                                allowOtherJobTitle:
                                    camp.data.allowOtherJobTitle,
                                unitSize: camp.unitSize,
                                enableDigitalCards: camp.enableDigitalCards,
                                salesforceEnabled: camp.salesforceEnabled,
                                defaultLanguage:
                                    camp.defaultLanguage || Languages.English,
                            } as AddCampaignForm;

                            this.fetchCampaignUsers()
                                .then(users => {
                                    this.campaignUsers = users;
                                })
                                .then(() => {
                                    this.$modal.show('campaign-modal');
                                });
                        });
                });
        },
        afterCampaignDialogOpen() {
            this.initPopovers();
            $('.summernote.create').summernote({
                placeholder: signupTextHtml,
                toolbar: summernoteToolbar,
                dialogsInBody: true,
                height: 360,
            });
            $('.summernote.create').on('summernote.change', (_, val) =>
                this.onCreateSummernoteChange(val)
            );

            this.getPropertyToken();

            const TagButton = function() {
                const ui = $.summernote.ui;

                const button = ui.buttonGroup([
                    ui.button({
                        contents:
                            '<span class="material-icons text-sm">local_offer</span><span class="material-icons text-sm">arrow_drop_down</span>',
                        tooltip: 'Insert tag',
                        data: {
                            toggle: 'dropdown',
                        },
                    }),
                    ui.dropdown({
                        items: [
                            'First Name',
                            'Last Name',
                            'Employer',
                            'Auth Card Answers',
                            'LocalNumber',
                            'CellPhone',
                            'EmailAddress',
                            'Referer',
                            'Region',
                            'Rating',
                            'Department',
                            'Address',
                            'City',
                            'State',
                            'Zip',
                            'EmployeeId',
                            'ReasonsForJoining',
                            'Shift',
                        ],
                        click: function(e) {
                            const item = e.target.innerText;
                            const tag =
                                EmailTemplateTag[item.replace(/\s/g, '')];

                            $('.summernote.email').summernote(
                                'editor.insertText',
                                tag
                            );
                        },
                    }),
                ]);

                return button.render();
            };

            $('.summernote.submission').summernote({
                toolbar: summernoteToolbar,
                dialogsInBody: true,
                height: 360,
            });
            $('.summernote.submission').on('summernote.change', (_, val) => {
                this.form.submissionTemplate = val;
            });

            $('.summernote.email').summernote({
                placeholder: emailTemplate,
                toolbar: [
                    ['font', ['fontsize', 'bold', 'underline', 'clear']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'tags']],
                    ['view', ['codeview', 'help']],
                ],
                buttons: {
                    tags: TagButton,
                },
                dialogsInBody: true,
                height: 384,
            });

            $('.summernote.email').on('summernote.change', (_, val) => {
                this.form.emailTemplate = val;
            });

            if (this.form.id) {
                $('.summernote.create').summernote('code', this.form.header);
                $('.summernote.submission').summernote(
                    'code',
                    this.form.submissionTemplate
                );
                $('.summernote.email').summernote(
                    'code',
                    this.form.emailTemplate
                );
            } else {
                Vue.set(this.form, 'adminTags', [
                    {
                        text: store.token.userName,
                        tiClasses: ['ti-valid'],
                    },
                ]);
            }
            this.setupAutocomplete();
        },
        afterCampaignDialogClose() {
            this.resetForm();
            $('.summernote.create').summernote('code', '');
            this.$validator.reset();
        },
        getSelectedRows() {
            // get rows here
            const selectedRows = this.gridOptions.api.getSelectedRows();
            const selectedIds = selectedRows.map(row => row.id);
            this.selectedCampaigns = selectedRows;
        },
        removeCampaignsFromGrid(campaignIds: number[]) {
            const newRows = this.rowData.filter(row => {
                return !campaignIds.find(id => row.id === id);
            });
            this.rowData = newRows;
        },
        deleteCampaigns(campaigns: Campaign[]) {
            const campaignIds = campaigns.map(campaign => campaign.id);

            axios
                .delete(`${process.env.VUE_APP_API_URI}/api/admin/weblinks`, {
                    data: {
                        Ids: campaignIds,
                    },
                })
                .then(res => {
                    let data = JSON.parse(res.config.data);
                    this.removeCampaignsFromGrid(data.Ids);
                })
                .then(() => {
                    this.closeDeleteModal();
                });
        },
        setRegionFilter(e) {
            let opts = Array.from(e.target.selectedOptions);
            let regions = opts.map(opt => (<HTMLInputElement>opt).value);
            this.filters.regions = regions;
        },
        setCampaignFilter(campaign: string) {
            this.filters.campaign = campaign;
        },
        clearFilters() {
            this.filters.regions = [];
            this.filters.campaign = '';
            this.filters.noAdmins = false;
            $('.selectpicker').selectpicker('deselectAll');
        },
        hasAdminCampaigns() {
            return store.hasAdminCampaigns;
        },
        fetchCampaignUsers() {
            if (!this.form.id) {
                return;
            }

            return axios
                .get(
                    `${process.env.VUE_APP_API_URI}/api/admin/weblinks/${this.form.id}/users`
                )
                .then(res => {
                    if (res.status !== 200) {
                        Utils.toastError('Unable to fetch campaign users');
                        return;
                    }

                    return res.data;
                });
        },
        onCreateSummernoteChange(val: string) {
            this.form.header = val;
        },
        resetCreateHeader() {
            const reset = confirm(
                'Are you sure you want to reset the header back to the default?'
            );
            if (reset) {
                this.form.header = '';
                $('.summernote.create').summernote('code', this.form.header);
            }
        },
        resetSubmissionTemplate() {
            const reset = confirm(
                'Are you sure you would like to reset the submission template back to the default?'
            );
            if (reset) {
                this.form.submissionTemplate = '';
                $('.summernote.submission').summernote(
                    'code',
                    this.form.submissionTemplate
                );
            }
        },
        resetEmailTemplate() {
            const reset = confirm(
                'Are you sure you would like to reset the email template back to the default?'
            );

            if (reset) {
                (this.form.emailTemplate = ''),
                    $('.summernote.email').summernote(
                        'code',
                        this.form.emailTemplate
                    );
            }
        },
        deleteJobTitle(i, form) {
            form.jobTitles.splice(i, 1);
        },
        addJobTitle(form) {
            form.jobTitles.push('');
        },
        handleJobTitleInput(e, i) {
            const jobTitles = e.target.value.trim().split('\n');
            if (jobTitles.length <= 1) {
                return;
            }

            const newJobTitles = [...this.form.jobTitles];

            newJobTitles.splice(i, 1, ...jobTitles);

            this.form.jobTitles = [...new Set(newJobTitles)];
        },
        deleteDepartment(i, form) {
            form.departments.splice(i, 1);
        },
        addDepartment(form) {
            form.departments.push('');
        },
        handleDepartmentInput(e, i) {
            const deps = e.target.value.trim().split('\n');
            if (deps.length <= 1) {
                return;
            }

            const newDeps = [...this.form.departments];

            newDeps.splice(i, 1, ...deps);

            this.form.departments = [...new Set(newDeps)];
        },
        exportCards() {
            const campaign: WebLink = this.selectedCampaigns[0];
            this.loading.cardsExport = true;

            axios
                .get(
                    `${process.env.VUE_APP_API_URI}/api/admin/export-cards/${campaign.id}`,
                    {
                        responseType: 'blob',
                    }
                )
                .then(res => {
                    const blobUrl = URL.createObjectURL(res.data);

                    const link = document.createElement('a');
                    link.setAttribute('href', blobUrl);

                    link.setAttribute(
                        'download',
                        `${campaign.title} cards.pdf`
                    );
                    link.innerHTML = 'Click Here to download';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    this.loading.cardsExport = false;
                })
                .catch(e => {
                    console.error(e);

                    this.loading.cardsExport = false;
                    Utils.toastError(
                        'Failed to generate signups export. Try again later'
                    );
                });
        },
        exportSignups() {
            const campaign: WebLink = this.selectedCampaigns[0];
            this.loading.signupsExport = true;
            axios
                .get(
                    `${process.env.VUE_APP_API_URI}/api/admin/export-signups/${campaign.id}`,
                    {
                        responseType: 'blob',
                    }
                )
                .then(res => {
                    const blobUrl = URL.createObjectURL(res.data);

                    const link = document.createElement('a');
                    link.setAttribute('href', blobUrl);

                    link.setAttribute(
                        'download',
                        `${campaign.title} signups.pdf`
                    );
                    link.innerHTML = 'Click Here to download';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    this.loading.signupsExport = false;
                })
                .catch(e => {
                    console.error(e);

                    this.loading.signupsExport = false;
                    Utils.toastError(
                        'Failed to generate signups export. Try again later'
                    );
                });
        },
        viewPoster() {
            const camp = this.selectedCampaigns[0];
            // this.$router.push(`/${camp.path}/print`);
            window.open(`/${camp.path}/print`, '_blank');
        },

        async copyVueInputTags(id) {
            const input = document.querySelector("[id='" + id + "']");
            const spans = input.querySelectorAll("[class='ti-tag-center']");
            let values = [];
            Utils.toastSuccess('Reasons for joining copied to clipboard.');
            spans.forEach(element => {
                element.firstChild.childNodes.forEach(child => {
                    if (child.nodeValue) {
                        values.push(child.nodeValue);
                    }
                });
            });
            await navigator.clipboard.writeText(values.join('; '));
        },

        onFilterTextBoxChanged(e) {
            this.gridOptions.api.setQuickFilter(e.target.value);
        },

        trimTags(tagObj) {
            tagObj['tag']['text'] = (tagObj['tag']['text'] as string).trim();
            tagObj.addTag();
        },
        async openCampaignManagersModal() {
            this.bulkOp.loading = true;
            this.bulkOp.error = '';
            this.bulkOp.selectedUser = null;
            this.bulkOp.userCampaigns = [];
            this.bulkOp.selectedCampaignIds = [];
            this.bulkOp.newManagerEmail = '';
            this.bulkOp.selectAll = false;
            this.$modal.show('campaign-managers-modal');

            try {
                const [usersRes, campaignsRes] = await Promise.all([
                    axios.get(`${process.env.VUE_APP_API_URI}/api/admin/users`),
                    axios.get(`${process.env.VUE_APP_API_URI}/api/admin/weblinks`),
                ]);
                this.bulkOp.allUsers = usersRes.data;
                this.bulkOp.allCampaigns = campaignsRes.data.map((c: any) => ({
                    id: c.id,
                    title: c.title,
                    path: c.path,
                    region: c.region,
                    status: c.status,
                }));
            } catch (e) {
                this.bulkOp.error = 'Failed to load data. Please try again.';
            } finally {
                this.bulkOp.loading = false;
            }
        },
        onBulkUserSelect(user: User) {
            this.bulkOp.selectedUser = user;
            this.bulkOp.selectedCampaignIds = [];
            this.bulkOp.selectAll = false;
            if (!user) {
                this.bulkOp.userCampaigns = [];
                return;
            }
            this.bulkOp.userCampaigns = this.bulkOp.allCampaigns.filter((c) =>
                user.campaignIds.includes(c.id)
            );
        },
        toggleAllBulkCampaigns() {
            if (this.bulkOp.selectAll) {
                this.bulkOp.selectedCampaignIds = this.bulkOp.userCampaigns.map((c) => c.id);
            } else {
                this.bulkOp.selectedCampaignIds = [];
            }
        },
        async submitBulkReassign() {
            if (!this.bulkOp.selectedUser || this.bulkOp.selectedCampaignIds.length === 0) return;

            this.bulkOp.loading = true;
            this.bulkOp.error = '';

            try {
                await axios.post(`${process.env.VUE_APP_API_URI}/api/admin/weblinks/bulk-reassign-admin`, {
                    removeUser: this.bulkOp.selectedUser.email,
                    addUser: this.bulkOp.newManagerEmail.trim() || null,
                    campaignIds: this.bulkOp.selectedCampaignIds,
                });

                const removedCount = this.bulkOp.selectedCampaignIds.length;
                this.$modal.hide('campaign-managers-modal');
                Utils.toastSuccess(
                    `Updated campaign managers for ${removedCount} campaign${removedCount !== 1 ? 's' : ''}`
                );
            } catch (e) {
                this.bulkOp.error = 'Failed to update campaign managers. Please try again.';
            } finally {
                this.bulkOp.loading = false;
            }
        },
    },
    watch: {
        'form.departments'(val, oldVal) {
            const regex = /\n/g;
            if (val.some(dep => regex.test(dep))) {
                this.form.departments = this.form.departments.map(dep =>
                    dep.replace(/\n/g, '')
                );
            }
        },
    },
    computed: {
        Languages() {
            return Languages;
        },
        uiJoinSurveyResponsesOne(): string {
            return this.form.joinSurveyResponsesOne?.join(',');
        },
        uiJoinSurveyResponsesTwo(): string {
            return this.form.joinSurveyResponsesTwo?.join(',');
        },
        uiJoinSurveyResponsesThree(): string {
            return this.form.joinSurveyResponsesThree?.join(',');
        },
        uiJoinSurveyResponsesFour(): string {
            return this.form.joinSurveyResponsesFour?.join(',');
        },

        hasSelectedCampaigns(): boolean {
            return (this as any).selectedCampaigns.length > 0;
        },
        multipleRegions(): boolean {
            return (this as any).filterOpts.regions.length > 1;
        },
        userHasRegions(): boolean {
            return (
                store.token &&
                store.token.regions &&
                store.token.regions.length > 0
            );
        },
        isAdmin(): boolean {
            return store.token?.roles?.includes(Role.Admin);
        },
        canCreateCampaigns(): boolean {
            return (
                store.token?.roles?.includes(Role.CampaignManager) ||
                store.token?.roles?.includes(Role.Admin)
            );
        },
        filteredRowData(): WebLink[] {
            let rows = (this as any).rowData;
            if (this.filters.regions.length > 0) {
                rows = rows.filter(row => {
                    return this.filters.regions.includes(row.region);
                });
            }
            if (this.filters.noAdmins) {
                rows = rows.filter(row => row.adminCount === 0);
            }
            return rows;
        },
        emailPopoverMsg(): string {
            return `This template will be used for the signup confirmation email. ${this.popoverMsg}`;
        },
    },
    components: {
        AgGridVue,
        Titlebar,
        VueTagsInput,
    },
    beforeMount() {
        this.columnTypes = {
            dateColumn: {
                filter: 'agDateColumnFilter',
                valueFormatter: input =>
                    input.value &&
                    moment
                        .utc(input.value)
                        .local()
                        .format('MM/DD/YYYY hh:mm a'),
            },
            phoneColumn: {
                valueFormatter: input =>
                    input.value
                        .replace(/[^0-9]/g, '')
                        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'),
            },
        };

        this.columnDefs = [
            {
                field: 'title',
                checkboxSelection: true,
                getQuickFilterText: (params: { data: WebLink }) => {
                    return params.data.title;
                },
            },
            {
                field: 'path',
                cellRenderer: (params: { data: WebLink }) => {
                    return `<a href="/${params.data.path}" target="_blank">${params.data.path}</a>`;
                },
                getQuickFilterText: (params: { data: WebLink }) => {
                    return params.data.path;
                },
            },
            {
                field: 'dateCreated',
                type: 'dateColumn',
                sort: 'desc',
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'description',
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'referrer',

                cellRenderer: (params: { data: WebLink }) => {
                    return params.data.referrer || '';
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                headerName: 'Employers',
                valueGetter: (params: { data: WebLink }) => {
                    let employerName;

                    const hasEmployers = params.data.data.employers;

                    if (hasEmployers) {
                        const firstEmployer = params.data.data.employers.find(
                            emp => {
                                return emp.name && emp.name.length !== 0;
                            }
                        );
                        const count = params.data.data.employers.length - 1;

                        if (!firstEmployer && count <= 0) {
                            return '';
                        }

                        employerName =
                            firstEmployer && firstEmployer.name
                                ? `${count + 1} - ${firstEmployer.name}` +
                                  (count > 0
                                      ? ` & ${count} other${
                                            count > 1 ? 's' : ''
                                        }`
                                      : '')
                                : `${count + 1} employer${
                                      count > 1 ? 's' : ''
                                  } `;
                    } else {
                        employerName = params.data.data['employeeName'];
                    }

                    return employerName;
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                headerName: 'Employer Names',
                valueGetter: (params: { data: WebLink }) => {
                    let employerName;

                    const hasEmployers = params.data.data.employers;

                    if (hasEmployers) {
                        const firstEmployer = params.data.data.employers.find(
                            emp => {
                                return (
                                    emp.location &&
                                    emp.location.name &&
                                    emp.location.name.length
                                );
                            }
                        );
                        const count = params.data.data.employers.length - 1;

                        if (!firstEmployer && count <= 0) {
                            return '';
                        }

                        employerName =
                            firstEmployer &&
                            firstEmployer.location &&
                            firstEmployer.location.name
                                ? `${firstEmployer.location.name}` +
                                  (count > 0
                                      ? ` & ${count} other${
                                            count > 1 ? 's' : ''
                                        }`
                                      : '')
                                : `${count + 1} employer${
                                      count > 1 ? 's' : ''
                                  } `;
                    } else {
                        employerName = params.data.data['employeeName'];
                    }

                    return employerName;
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                headerName: 'Reply-To Email',
                valueGetter: (params: { data: WebLink }) => {
                    return params.data.data['replyEmail'];
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                headerName: 'Unit Size',
                valueGetter: params => {
                    return params.data.unitSize;
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'localNumber',
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'region',
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'status',
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'disabled',
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                headerName: 'Signups',
                valueGetter: params => {
                    return params.data.totalSignups;
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'salesforceEnabled',
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                headerName: 'Total Referrals',
                valueGetter: params => {
                    return params.data.totalReferrals;
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                headerName: 'Total Referral Signups',
                valueGetter: params => {
                    return params.data.totalReferralSignups;
                },

                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'tags',
                cellRenderer: (params: { data: WebLink }) => {
                    if (params.data.tags) {
                        const tagList = !Array.isArray(params.data.tags)
                            ? params.data.tags?.split(',')
                            : [];
                        return tagList
                            .map(x => {
                                return `<span class="label label-primary">${x}</span>`;
                            })
                            .join('');
                    }
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'joinSurveyResponsesOne',
                cellRenderer: (params: { data: WebLink }) => {
                    if (params.data.joinSurveyResponsesOne) {
                        const tagList = params.data.joinSurveyResponsesOne;
                        return tagList
                            .map(x => {
                                return `<span class="label label-primary">${x}</span>`;
                            })
                            .join('');
                    }
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'joinSurveyResponsesTwo',
                cellRenderer: (params: { data: WebLink }) => {
                    if (params.data.joinSurveyResponsesTwo) {
                        const tagList = params.data.joinSurveyResponsesTwo;
                        return tagList
                            .map(x => {
                                return `<span class="label label-primary">${x}</span>`;
                            })
                            .join('');
                    }
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'joinSurveyResponsesThree',
                cellRenderer: (params: { data: WebLink }) => {
                    if (params.data.joinSurveyResponsesThree) {
                        const tagList = params.data.joinSurveyResponsesThree;
                        return tagList
                            .map(x => {
                                return `<span class="label label-primary">${x}</span>`;
                            })
                            .join('');
                    }
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
            {
                field: 'joinSurveyResponsesFour',
                cellRenderer: (params: { data: WebLink }) => {
                    if (params.data.joinSurveyResponsesFour) {
                        const tagList = params.data.joinSurveyResponsesFour;
                        return tagList
                            .map(x => {
                                return `<span class="label label-primary">${x}</span>`;
                            })
                            .join('');
                    }
                },
                getQuickFilterText: () => '', //prevents quickfilter from using this column
            },
        ] as ColDef[];

        const adminCampaigns = fetchAdminCampaigns();

        const campaigns = Promise.all([adminCampaigns])
            .then(campaigns => {
                this.$forceUpdate();
                return campaigns[0];
            })
            .then(campaigns => {
                this.rowData = campaigns;
                if (this.$props.campaignPath) {
                    const campaign = campaigns.find(
                        camp => camp.path === this.$props.campaignPath
                    );

                    if (campaign) {
                        this.populateEditModal(campaign);
                    }
                }
            })
            .catch(err => {
                let errorMessage = '';
                if (
                    err.response &&
                    err.response.status ===
                        AppConstants.HttpStatusCode.Unauthorized
                ) {
                    errorMessage = 'Unauthorized: please log out and back in';
                } else {
                    errorMessage =
                        "Couldn't retrieve the data. Please try again later";
                }
                Utils.toastError(errorMessage);
            });
    },
    mounted: function() {
        this.$nextTick(() => {
            $('[data-toggle="popover"]').popover();

            const tagInputs = document.querySelectorAll('.focus-on-blank-tab');

            this.loadGridState();

            const onStateChangeEvents = [
                'columnResized',
                'filterChanged',
                'displayedColumnsChanged',
                'sortChanged',
            ];
            onStateChangeEvents.forEach(e =>
                this.gridOptions.api.addEventListener(e, this.onStateChanged)
            );

            Array.from(tagInputs).forEach(input => {
                input.addEventListener('keydown', e => {
                    if ((e as KeyboardEvent).code !== 'Tab') {
                        return;
                    }

                    if (this.form.admin) {
                        return;
                    }

                    try {
                        ((e.target as Element).parentNode.parentNode.parentNode
                            .parentNode.parentNode.nextSibling as Element)
                            .querySelector('input')
                            .focus();
                    } catch (e) {}
                });
            });

            // Pull the user's regions from their JWT
            if (store.token)
                this.filterOpts.regions = store.token.regions.sort((a, b) =>
                    a > b ? 1 : -1
                );

            // Wait for Vue to render the v-if select before initializing selectpicker
            this.$nextTick(() => {
                $('#region-select').selectpicker();
            });

            this.gridOptions.api.addEventListener(
                'rowSelected',
                this.getSelectedRows
            );
        });
    },
});
